import dayjs from "dayjs";
const load = async ({ params }) => {
  let start = params.date ? dayjs(params.date) : dayjs().startOf("week");
  return {
    page_title: "Calendar",
    start,
    days: Array.from({ length: 7 }, (_, i) => start.add(i, "day"))
  };
};
export {
  load
};
//# sourceMappingURL=_page.ts.js.map
